var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AboutUs"},[_c('au_header'),_c('au_info'),_c('co_org')],1)}
var staticRenderFns = []

export { render, staticRenderFns }